import React, {Component} from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import * as firebase from 'firebase';
import 'firebase/firestore';
import logo from './logo.svg';
import './App.css';
import Homepage from './Homepage';
import Gamepage from './Gamepage';
import Tutorial from './Tutorial';
import StatusPage from './StatusPage';

// Initialize Firebase
const config = {
  apiKey: 'AIzaSyC3ZslVkfYRCunI_LJUF7O-Mq1a2x1A0KE',
  authDomain: 'thumbbattlebot.firebaseapp.com',
  databaseURL: 'https://thumbbattlebot.firebaseio.com',
  projectId: 'thumbbattlebot',
  storageBucket: 'thumbbattlebot.appspot.com',
  messagingSenderId: '818193735646',
};
firebase.initializeApp(config);

class App extends Component {
  getBaseComponent = () => (
    <div className="App">
      <div className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h2>Welcome to React</h2>
      </div>
      <p className="App-intro">
        To get started, edit <code>src/App.js</code> and save to reload.
      </p>
    </div>
  );

  redirectToHome = () => <Redirect to="/" />;

  render() {
    return (
      <Router>
        <div>
          <Switch>
            <Route exact path="/" component={Homepage} />
            <Route exact path="/tutorial" component={Tutorial} />
            <Route path="/game/:gameId" component={Gamepage} />
            <Route exact path="/stat" component={StatusPage} />
            <Route render={this.redirectToHome} />
          </Switch>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js